import type { ReactNode } from 'react';

import { NavigationItem } from './NavigationItem';

import styles from './mainNavigation.module.scss';

export type Item = {
  id?: string;
  href?: string;
  iconName: string;
  label: string;
  sublabels?: string[];
  tooltip?: ReactNode;
};

export type MainNavigationProps = {
  activeItemIndex?: number;
  className?: string;
  collapsed: boolean;
  collapsedTooltipWidth?: string;
  items: Item[];
  isDetailsPageSection?: boolean;
  onClick?: (item: Item) => void;
  onClose?: (itemId: string) => void;
  isPending?: boolean;
};

function getCloseHandler(item: Item, onClose?: (itemId: string) => void) {
  const { id } = item;
  if (!onClose || id == null) {
    return undefined;
  }

  return () => onClose(id);
}

export function MainNavigation({
  activeItemIndex,
  collapsed,
  collapsedTooltipWidth,
  items,
  isDetailsPageSection,
  onClick,
  onClose,
  isPending,
}: MainNavigationProps) {
  return (
    <div className={styles['root']}>
      {items.map((item, index) => (
        <NavigationItem
          key={`${item.label}/${item.href}`}
          active={
            activeItemIndex !== undefined ? index === activeItemIndex : false
          }
          collapsed={collapsed}
          collapsedTooltipWidth={collapsedTooltipWidth}
          iconName={item.iconName}
          isDetailsPageSection={isDetailsPageSection}
          label={item.label}
          sublabels={item.sublabels}
          tooltip={item.tooltip}
          onClick={() => onClick?.(item)}
          onClose={getCloseHandler(item, onClose)}
          isPending={isPending}
        />
      ))}
    </div>
  );
}
